import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import { PeriodEndReportFundOverviewDatapoints } from 'further-types/lp/period-end-report';
import theme from '../Pdf/components/theme';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import PeriodEndReportDatapointsTable from './components/pdf/PeriodEndReportDatapointsTable';
import SectionTitle from './components/pdf/SectionTitle';
import SubsectionTitle from './components/pdf/SubsectionTitle';
import { PeriodEndReportSectionPageProps } from './types';

const styles = StyleSheet.create({
  capitalBalanceSubsectionTitle: {
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
  performanceSnapshotSubsectionTitle: {
    paddingTop: theme.spacing(theme.spacingSizes.lg),
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  capitalBalanceDatapoints: PeriodEndReportFundOverviewDatapoints;
  performanceSnapshotDatapoints: PeriodEndReportFundOverviewDatapoints;
};

const CommitmentOverview: FC<Props> = ({
  capitalBalanceDatapoints,
  performanceSnapshotDatapoints,
  sectionNumber,
  ...rest
}) => {
  return (
    <PeriodEndReportPage
      {...rest}
      header={`0${sectionNumber} – Commitment overview`}
    >
      <SectionTitle sectionNumber={sectionNumber} title="Commitment overview" />
      <SubsectionTitle
        sectionNumber={sectionNumber}
        subsectionNumber={1}
        title="Capital balance"
        paddedTop
        style={styles.capitalBalanceSubsectionTitle}
      />
      <PeriodEndReportDatapointsTable datapoints={capitalBalanceDatapoints} />
      <SubsectionTitle
        sectionNumber={sectionNumber}
        subsectionNumber={2}
        title="Performance snapshot"
        style={styles.performanceSnapshotSubsectionTitle}
      />
      <PeriodEndReportDatapointsTable
        datapoints={performanceSnapshotDatapoints}
      />
    </PeriodEndReportPage>
  );
};

export default CommitmentOverview;
